<template>
  <div style="display: inline">
    <el-button :disabled="payBackLoadding" @click="showPayBack" v-if="userAuth.can_batch_refund"
               class="d-flex-row funcbars-button" size="mini" style="margin-right: 10px"><i
        class="el-icon-plus"></i>回款记录
    </el-button>

    <el-dialog title="添加回款记录" :visible.sync="dialogPayback" width="80%" :append-to-body="true">
      <el-form ref="payback" :rules="rules" :model="payBack.tableForm" label-width="100px" size="mini">
        <el-row>
          <el-col :span="8">
            <el-form-item label="付款方式：" prop="pay_term">
              <el-select v-model="payBack.tableForm.pay_term" placeholder="选择付款方式" clearable>
                <el-option
                    v-for="item in pay_methods"
                    :key="item.value + 'payback'"
                    :label="item.value"
                    :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结款时间：" prop="transfer_time">
              <el-date-picker v-model="payBack.tableForm.transfer_time"
                              placeholder="请选择结款时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="本次回款总额：" label-width="130px">
              <span
                  style="color: #FF5722;font-weight: 600;font-size: 18px"> {{
                  moneyFormat(payBack.tableForm.amount)
                }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-table" v-loading="payBackLoadding">
        <el-table :max-height="280" :data="payBack.tableData">
          <el-table-column
              width="60"
              label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column key="订单ID" label="订单ID" prop="id" align="left" :min-width="80"></el-table-column>
          <el-table-column key="订单编号" label="订单编号" prop="order_no" align="left" :min-width="100"
                           show-overflow-tooltip></el-table-column>
          <el-table-column key="客户名称" label="客户名称" prop="customer.name" align="left" show-overflow-tooltip
                           :min-width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.customer_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
              key="订单总额"
              label="订单总额"
              prop="payment_account"
              align="left"
              :min-width="100"
          >
            <template slot-scope="scope">
              <span>{{ moneyFormat(scope.row.payment_account) }}</span>
            </template>
          </el-table-column>
          <el-table-column key="剩余金额" label="剩余金额" prop="sum_amount" align="left" :min-width="100">
            <template slot-scope="scope">
              <span>{{ moneyFormat(scope.row.payment_account - scope.row.sum_amount) }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="快捷操作"
              width="100" align="center" header-align="center" fixed="right">
            <template slot-scope="scope">
              <el-link type="primary" @click="setDefaultAllPayment(scope.row)"><i
                  class="el-icon-check"></i>全额回款
              </el-link>
            </template>
          </el-table-column>
          <el-table-column key="本次回款金额" label="本次回款金额" align="left" :min-width="144" fixed="right">
            <editable-cell :show-input="true" slot-scope="{row}" v-model="row.nowPayBack"
                           @change="payBackChange" :is-input-number="true" placeholder="输入回款金额">
                          <span slot="content">
                            <span class="money">{{ moneyFormat(row.nowPayBack) }}</span>
                            <i class="el-icon-edit float-right"></i>
                          </span>
            </editable-cell>
          </el-table-column>
          <el-table-column key="备注" label="备注" align="left" :min-width="144" fixed="right">
            <editable-cell :show-input="true" slot-scope="{row}" v-model="row.remark" placeholder="输入备注"
                           :is-input-number="false">
                          <span slot="content">
                            <span class="money">{{ row.remark }}</span>
                            <i class="el-icon-edit float-right"></i>
                          </span>
            </editable-cell>
          </el-table-column>
          <el-table-column key="操作项" label="操作项" header-align="center" width="140" fixed="right">
            <template slot-scope="scope">
              <div style="display: flex">
                <div class="buttons d-flex-row align-items-center" style="flex:1!important;">
                  <a @click="showRecording(scope.row)"><i class="el-icon-document"></i>详情</a>
                </div>
                <div class="buttons d-flex-row align-items-center" style="flex:1!important;">
                  <a @click="delRecording(scope.$index)" style="color: #F56C6C"><i class="el-icon-close"></i>移除</a>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-show="payBack.err.display" style="color: #F56C6C;">{{ payBack.err.msg }}</div>

      <div style="text-align:center;margin-top: 20px;">
        <el-button type="primary" class="el-button--operation" @click="submitPayBack" size="mini"
                   :disabled="commitLoading" :loading="commitLoading"
                   style="margin-right:30px;width: 100px">确认
        </el-button>
        <el-button type="info" @click="dialogPayback=false"
                   style="width: 100px;background-color: #fff;color: #0C0C0C" size="mini">取消
        </el-button>
      </div>
      <el-dialog :append-to-body="true" :title="payBack.recording_title" :visible.sync="payBack.recording">
        <el-row>
          订单总额：<span
            style="color: #FF5722;font-weight: 600;font-size: 18px">{{
            moneyFormat(payBack.recording_payment_account)
          }}</span>&emsp;
          剩余金额：<span
            style="color: #FF5722;font-weight: 600;font-size: 18px">{{
            moneyFormat(payBack.recording_surplus_money)
          }}</span>
        </el-row>
        <div class="default-table" v-loading="payBackDetailLoading">
          <el-table :max-height="500" :data="payBack.recording_tableData"
                    style="margin-top: 10px"
                    :row-class-name="rowClassName" border>
            <el-table-column label="序号" prop="index" align="center" :min-width="80"></el-table-column>
            <el-table-column key="回款时间" label="回款时间" prop="transfer_time" align="center" :min-width="120"/>
            <el-table-column key="回款金额" label="回款金额" header-align="center" align="right" :min-width="120">
              <template slot-scope="scope">
                {{ moneyFormat(scope.row.amount) }}
              </template>
            </el-table-column>
            <el-table-column key="收款方式" label="收款方式" prop="pay_term" align="center" :min-width="100"/>
            <el-table-column key="备注" label="备注" prop="remark" header-align="center" align="left" :min-width="144">
              <template slot-scope="scope">
                {{ scope.row.remark || '-' }}
              </template>
            </el-table-column>
            <el-table-column key="创建时间" label="创建时间" prop="created_at" align="center" :min-width="144"/>
            <el-table-column key="修改时间" label="修改时间" prop="updated_at" align="center" :min-width="144"/>
          </el-table>
        </div>
      </el-dialog>
    </el-dialog>

  </div>
</template>

<script>
import EditableCell from "@/components/EditableCell";
import {getAccountList, postAccountStoreBatch} from "@/api/adOrder";
import {mTofixed} from "@/views/adOrder/index";
import {gFunc} from "@/globalFunc";

export default {
  name: "AdPayRecordOpt",
  components: {
    EditableCell
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      }
    },
    pay_methods: {
      type: [Array, Object],
      default() {
        return {};
      }
    }
  },
  data() {
    let overAmount = (rule, value, callback) => {
      if (value === 0) {
        callback();
      } else {
        callback(new Error("请完全分配金额"));
      }
    };

    return {
      dialogPayback: false,
      payBackLoadding: false,
      commitLoading: false,
      payBackDetailLoading: false,
      payBack: {
        theadData: [
          {
            title: "订单编号",
            type: "string",
            name: "id"
          },
          {
            title: "客户名称",
            type: "string",
            name: "customer.name"
          },
          {
            title: "订单总额",
            type: "number",
            name: "payment_account"
          },
          {
            title: "已回款金额",
            type: "number",
            name: "sum_amount"
          },
          {
            title: "剩余需回款金额",
            type: "number",
            name: "remain_account"
          }
        ],
        tableData: [],
        tableForm: {
          pay_term: "",
          transfer_time: "",
          amount: 0,
          overAmount: 0
        },
        recording: false,
        recording_title: '',
        recording_tableData: [],
        err: {
          display: false,
          msg: ""
        },
      },
      rules: {
        overAmount: [{validator: overAmount, trigger: "blur"}],
        customer_name: [
          {required: true, message: "请选择客户名称", trigger: "change"}
        ],
        invoice_title: [
          {required: true, message: "请输入发票抬头", trigger: "change"}
        ],
        tax_id: [{required: true, message: "请输入税号", trigger: "change"}],
        address: [{required: true, message: "请输入地址", trigger: "change"}],
        telephone: [
          {required: true, message: "请输入电话", trigger: "change"}
        ],
        bank_name: [
          {required: true, message: "请输入开户行名称", trigger: "change"}
        ],
        bank_amount: [{required: true, message: "请输入银行账户", trigger: "change"}],
        content: [{required: true, message: "请选择发票内容", trigger: "blur"}],
        type: [{required: true, message: "请选择发票类型", trigger: "blur"}],
        pay_term: [{required: true, message: "请选择付款方式", trigger: "change"}],
        transfer_time: [{required: true, message: "请选择结款时间", trigger: "change"}],
      },
    }
  },
  watch: {
    dialogPayback: function () {
      this.payBack.tableForm.pay_term = "银行收款";
      this.payBack.tableForm.transfer_time = "";
      this.payBack.tableForm.amount = 0;
      this.payBack.tableForm.overAmount = 0;
    },
    "payBack.tableForm.amount": function (newVal) {
      this.payBack.tableForm.overAmount = newVal;
    },
    "payBack.tableForm.overAmount": function () {
      let _nowPayBack = 0;
      for (let index = 0; index < this.payBack.tableData.length; index++) {
        if (typeof this.payBack.tableData[index].nowPayBack === "number") {
          this.payBack.err.display = false;
          _nowPayBack = _nowPayBack + this.payBack.tableData[index].nowPayBack;
        } else {
          this.payBack.err.display = true;
          // this.payBack.err.msg = "回款金额必须为数字";
          return;
        }
      }
      this.payBack.tableForm.overAmount =
          this.payBack.tableForm.amount - _nowPayBack;
    },
    "payBack.tableData": {
      // eslint-disable-next-line
      handler: function (newVal, nowVal) {
        let _nowPayBack = 0;
        for (let index = 0; index < newVal.length; index++) {
          if (typeof newVal[index].nowPayBack === "number") {
            this.payBack.err.display = false;
            _nowPayBack = _nowPayBack + newVal[index].nowPayBack;
          } else {
            this.payBack.err.display = true;
            // this.payBack.err.msg = "回款金额必须为数字";
            return;
          }
        }
        this.payBack.tableForm.overAmount =
            this.payBack.tableForm.amount - _nowPayBack;
      },
      deep: true
    }
  },
  methods: {
    moneyFormat(val) {
      return gFunc.numberFormat(val, 2)
    },
    rowClassName({row, rowIndex}) {
      row.index = rowIndex + 1
      if ((rowIndex % 2) === 1) {
        return 'table-row commonTable-row'
      } else {
        return 'table-row success-row'
      }
    },
    showPayBack() {
      this.payBackLoadding = true;
      this.commitLoading = false;
      let _selectItems = [...this.dataList]

      if (_selectItems && _selectItems.length > 0) {
        this.payBack.tableData = [];
        let error_msg = false
        for (let index = 0; index < _selectItems.length; index++) {
          let el = _selectItems[index]
          if (el.bool_undo) {
            error_msg = '存在已撤单订单，请去除勾选后再次申请';
            break;
            // } else if (el.is_mark == 1 && el.pid != 0) {
            //   error_msg = '全案营销订单的子订单无需添加回款记录';
            //   break;
          }
          this.payBack.tableData.push(_selectItems[index]);
          this.$set(this.payBack.tableData[index], "nowPayBack", 0);
          this.$set(this.payBack.tableData[index], "remark", null);
        }
        if (error_msg) {
          this.showToast({
            h: this,
            icon: "el-icon-error",
            text: error_msg,
            duration: 2000
          });
          setTimeout(() => {
            this.payBackLoadding = false;
          }, 500);
          return;
        }
        this.dialogPayback = true;
        this.payBackLoadding = false;
      } else {
        this.payBackLoadding = false;
        this.showToast({
          h: this,
          text: "请选择要回款的订单",
          icon: "el-icon-warning"
        });
      }
    },
    submitPayBack() {
      let items = this.payBack.tableData
      let data = [];
      for (let index = 0; index < items.length; index++) {
        const item = items[index];
        if (item.nowPayBack === 0) {
          this.$notify.warning('回款金额不能等于0')
          return false;
        }
        if (!item.remark) {
          if (item.nowPayBack < 0) {
            // this.showToast({
            //   h: this,
            //   icon: "el-icon-error",
            //   text: "第" + (index + 1) + "行，回款金额小于0，备注不能为空",
            //   duration: 2000
            // });
            this.$notify.warning(`第${index + 1}行，回款金额小于0，备注不能为空`)
            return false;
          }
          if (item.payment_account - item.sum_amount < item.nowPayBack) {
            // this.showToast({
            //   h: this,
            //   icon: "el-icon-error",
            //   text: "第" + (index + 1) + "行，回款金额大于剩余回款金额，请填写备注！",
            //   duration: 2000
            // });
            this.$notify.warning(`第${index + 1}行，回款金额大于剩余回款金额，请填写备注`)
            return false;
          }
        }

        data.push({
          order_no: item.order_no,
          amount: item.nowPayBack || 0,
          remark: item.remark,
          transfer_time: this.payBack.tableForm.transfer_time,
          pay_term: this.payBack.tableForm.pay_term
        })
      }

      this.$refs.payback.validate(valid => {
        if (valid) {
          this.commitLoading = true
          postAccountStoreBatch({data: data}).then(() => {
            this.commitLoading = false

            this.dialogPayback = false
            this.$emit('saveSuccess')
            this.showToast({
              h: this,
              icon: "el-icon-success",
              text: "批量回款成功",
              duration: 2000
            })

          });
        } else {
          return false;
        }
      });
    },
    showRecording(row) {
      this.payBack.recording_title = row.customer_name + '-回款记录' || '回款记录'
      this.payBack.recording_surplus_money = row.payment_account - row.sum_amount
      this.payBack.recording_payment_account = row.payment_account
      this.payBack.recording_tableData = []
      this.payBackDetailLoading = true
      getAccountList({id: row.id}).then(res => {
        this.payBack.recording_tableData = res.model.data.data;
        this.payBackDetailLoading = false
      });
      this.payBack.recording = true;
    },
    delRecording(index) {
      if (this.payBack.tableData.length <= 1) {
        this.$notify.warning('最少保留一条明细')
        // this.showToast({
        //   h: this,
        //   text: "最少保留一条明细",
        //   icon: "el-icon-warning"
        // });
        return false
      }
      this.payBack.tableData.splice(index, 1)
    },
    setDefaultAllPayment(row) {
      row.nowPayBack = row.payment_account - row.sum_amount
      this.payBackChange()
    },
    payBackChange() {
      this.payBack.tableForm.amount = mTofixed(this.payBack.tableData.reduce((a, item) => a + Number(item.nowPayBack), 0), 4)
    },
  }
}
</script>
